import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { FILE_STORAGE_REPOSITORY_WEB_CONFIG } from './file-storage-repository-web.config';
import { EXTERNAL_FILE_STORAGE_API, ExternalFileStorageApi, FILE_STORAGE_API, FileStorageApi, FILE_STORAGE_V2_API, FileStorageV2Api } from './data-sources';
export var apiProviders = [{
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [FILE_STORAGE_REPOSITORY_WEB_CONFIG]
}, {
  provide: FILE_STORAGE_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new FileStorageApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: FILE_STORAGE_V2_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new FileStorageV2Api(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: EXTERNAL_FILE_STORAGE_API,
  useFactory: function useFactory() {
    return new ExternalFileStorageApi(new AxiosInstanceBuilder().withTimeout(0).toInstance());
  }
}];